import moment from 'moment';

export const TIMER_EVENTS = {
    STOP: "timer.stop",
    START: "timer.start",
    UPDATE: "timer.update",
}

export const TREE_EVENTS= {
    OPENROW: "tree.openrow",
    CLOSEROW: "tree.closerow",
    ENABLE_ROW: "tree.enabled_row", // OR DISABLE
    UPDATE_PARENT: "tree.update_parent", // OR DISABLE
    NEXT_FOCUS: "tree.next_focus", // OR DISABLE
}

export const WINDOW_EVENTS= {
    LOADING: "LOADING",
    LOADED : "LOADED",
    CLOSE_WINDOW : "CLOSE_WINDOW",
    MAX_WINDOW: "MAX_WINDOW",
    NORMAL_WINDOW: "NORMAL_WINDOW",
    SELECTED_WINDOW: "SELECTED_WINDOW"
    
}
export default class PPCEvent {
    private eventHolder = {};
    private elementId;
    private element;
    constructor(_elementId = null) {
        this.elementId = _elementId;
        if(_elementId) {
            this.element = document.getElementById(_elementId);
        }
    }
    
    public setElement = (_elementId) => {
        if(_elementId) {
            this.element = document.getElementById(_elementId);
        }
    }
    
    public add =(eventName, listner, intern = false) => {
        if(this.elementId && !this.element) {
            this.element = document.getElementById(this.elementId);
        }
        
        if(eventName && listner) {
            if(!this.eventHolder[eventName]) {
                if(!intern) {
                    if(this.element) {
                        this.element.addEventListener(eventName, listner);
                    } else {
                        window.addEventListener(eventName, listner);
                    }
                }
                this.eventHolder[eventName] = {intern: intern, listner: listner};
            }
        }
        };
    public dispatch =( eventName, data ) => {
        const event = new CustomEvent(eventName, {detail: data });
        let eventListner;
        if( this.eventHolder[eventName] ) {
            eventListner = this.eventHolder[eventName];
            
            if(eventListner.intern) {
                eventListner.listner(event);
            } else {
                if(this.elementId && !this.element) {
                    this.element = document.getElementById(this.elementId);
                }
                
                if(this.element) {
                    
                    this.element.dispatchEvent(event);
                } else {
                
                    window.dispatchEvent(event);
                }
            }
        }

                
        
        
    }
    
    public destroy =() => {
        Object.keys(this.eventHolder).map( (eventName, index) => {
            if(this.element) {
                this.element.removeEventListener(eventName, this.eventHolder[eventName]);
            } else {
                window.removeEventListener(eventName, this.eventHolder[eventName]);
            }
            
        });
    }
}
    
